const cookieName = 'newsletter_overlay_hidden';
const overlay = $('#newsletter-overlay');
const closeButton = $('#newsletter-overlay-close');
const submitLink = $('#newsletter-overlay-button');

function getCookie(name) {
    const prefix = encodeURIComponent(name) + '=';

    const cookie = document.cookie
        .split('; ')
        .find(entry => entry.startsWith(prefix));

    return cookie
        ? decodeURIComponent(cookie.substring(prefix.length))
        : null;
}

function hideOverlayFor30Days() {
    const maxAge = 30 * 24 * 60 * 60;

    document.cookie =
        encodeURIComponent(cookieName) + '=1' +
        '; Max-Age=' + maxAge +
        '; Path=/' +
        '; SameSite=Lax';

    overlay.addClass('newsletter_overlay_hidden');
}

// Nur anzeigen, wenn das Cookie noch nicht existiert.
if (overlay !== null && getCookie(cookieName) !== '1') {
    overlay.removeClass('newsletter_overlay_hidden');
}

closeButton.on('click', function() {
    hideOverlayFor30Days();
});

submitLink.on('click', function() {
    // Das Cookie wird synchron gesetzt, bevor der Browser dem Link folgt.
    hideOverlayFor30Days();
});
